module.exports = __webpack_public_path__ + "static/media/ascensor.35e82603.png";